import { useState, useEffect } from "react";
import "./ContentPopUp.css";

const defaultNode = {
  id: "default",
  name: "Welcome",
  details: {
    title: "Welcome to the Tulip Interactive Reference Architecture",
    text: "To begin, select your journey and then select a highlighted box in the diagram to learn more. If you want to start over, click Reset. If you want to explore beyond Journeys, click into the individual boxes within the diagram.",
  },
};

const ContentPopUp = ({ selectedNode, setSelectedNode, selectedJourney }) => {
  const [popupContent, setPopupContent] = useState(defaultNode);

  useEffect(() => {
    if (selectedNode) {
      setPopupContent(selectedNode);
    } else if (selectedJourney) {
      setPopupContent({
        id: "popUp",
        details: {
          title: selectedJourney.title,
          text: selectedJourney.description,
        },
      });
    } else {
      setPopupContent(defaultNode);
    }
  }, [selectedNode, selectedJourney]);

  const { details } = popupContent;

  return (
    <div className="assetContainer">
      <div className="paneldetail">
        <div className="popup-header">
          <div className="popup-title">{details.title}</div>
          {/* Uncomment the following button for closing functionality */}
          {/* <button className="close-button" onClick={() => setSelectedNode(null)}></button> */}
        </div>

        {details.image && (
          <div className="popup-image-container">
            <img
              className="popup-image"
              src={details.image}
              alt={details.image}
            />
          </div>
        )}
        <div className="description-text">{details.text}</div>
        {details.button1title && (
          <a
            href={details.link}
            target="_blank"
            rel="noopener noreferrer"
            className="popup-button"
          >
            {details.button1title}
          </a>
        )}
      </div>
    </div>
  );
};

export default ContentPopUp;
